export default __webpack_public_path__ + "images/kvdbil-logo.png";